import { initialState } from 'store/Auth'

export const selectAuthToken = ({ Auth }) =>
  Auth?.authToken || initialState?.authToken

export const selectAuthedUser = ({ Auth }) =>
  Auth?.authedUser || initialState?.authedUser
